<div class="dc-dialog-wrap">
  <div class="dc-dialog-header">
    <div class="dc-header-left">
      <span class="dc-title-icon">🎯</span>
      <span class="dc-title">Dnevni izzivi</span>
    </div>
    <div class="dc-dialog-header-right">
      <div class="dc-streak">
        <span class="dc-streak-icon">🔥</span>
        <span class="dc-streak-text">{{streakText}}</span>
      </div>
      <button class="dc-close-btn" (click)="close()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
             stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
  </div>

  <p class="dc-subtitle">Reši 3 izzive in izboljšaj kakovost podatkov</p>

  <div class="dc-progress-section">
    <div class="dc-progress-track">
      <div class="dc-progress-fill" [style.width.%]="progressPct"></div>
    </div>
    <span class="dc-progress-counter">{{progressCurrent}}/{{progressTotal}}</span>
  </div>

  <div class="dc-items">
    @for (item of items; track item) {
      <div class="dc-item" [class.dc-item-done]="item.Done">
        <span class="dc-item-icon" [class.dc-item-icon-done]="item.Done"></span>
        <span class="dc-item-label">{{item.Label}}</span>
        @if (item.Done) {
          <span class="dc-xp-badge">+{{item.Xp}} XP</span>
        }
      </div>
    }
  </div>

  <div class="dc-footer">
    <div class="dc-avatars">
      <span class="dc-avatar dc-avatar-green">Mk</span>
      <span class="dc-avatar dc-avatar-blue">Aj</span>
      <span class="dc-avatar dc-avatar-red">SS</span>
      <span class="dc-footer-text">{{footerActiveText}}</span>
    </div>
    <a class="dc-leaderboard-link">{{leaderboardLinkText}}</a>
  </div>
</div>
